var _circle, _path, _path2, _path3, _circle2, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboardInProgress = function SvgDashboardInProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#dashboard-in-progress_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.75 27.75 21 40c9.625-.625 17.5-7.5 19-18L29 11z",
    clipRule: "evenodd",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFCF2",
    fillRule: "evenodd",
    d: "M28.125 10.625h-17.5c-.687 0-1.25.563-1.25 1.25v15c0 .688.563 1.25 1.25 1.25h17.5c.688 0 1.25-.562 1.25-1.25v-15c0-.687-.562-1.25-1.25-1.25",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#344E5F",
    d: "M9.375 13.125h20v1.25h-20z",
    opacity: 0.149
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.625,
    cy: 11.875,
    r: 0.625,
    fill: "#F3643F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDC03D",
    fillRule: "evenodd",
    d: "M12.5 11.25c-.375 0-.625.25-.625.625s.25.625.625.625.625-.25.625-.625-.25-.625-.625-.625m10.625 4.375v7.5h5v-7.5z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3DBB69",
    fillRule: "evenodd",
    d: "M14.375 12.5c.375 0 .625-.25.625-.625s-.25-.625-.625-.625-.625.25-.625.625.25.625.625.625m-3.75 3.125v11.25h11.25v-11.25z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dashboard-in-progress_svg__a",
    x1: 0,
    x2: 40,
    y1: 40,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7D8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A569"
  })))));
};
export { SvgDashboardInProgress as ReactComponent };
export default __webpack_public_path__ + "fonts/dashboard-in-progress-62323c69899bdbe9743a5ed08a8aa5e3.svg";